import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-20 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="relative w-full h-[280px] md:h-[340px] rounded-2xl overflow-hidden mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Beautifully%20styled%20flat%20lay%20of%20assorted%20premium%20fashion%20accessories%20including%20a%20leather%20wallet%20sunglasses%20a%20silk%20scarf%20and%20a%20minimalist%20watch%20on%20a%20warm%20cream%20linen%20surface%2C%20soft%20afternoon%20light%2C%20editorial%20lifestyle%20photography%2C%20rich%20neutral%20beige%20and%20sand%20tones%2C%20elegant%20lifestyle%20composition&width=1400&height=800&seq=cta-v2-brandnew&orientation=landscape"
              alt="CSSBuy Sheet full accessory collection"
              title="Explore the complete CSSBuy Spreadsheet collection"
              className="w-full h-full object-cover"
            />
          </div>

          <p className="text-2xl md:text-3xl font-heading font-medium text-foreground-900 leading-relaxed mb-2">
            Ready to level up your
          </p>
          <p className="text-2xl md:text-3xl font-heading font-medium text-foreground-900 leading-relaxed mb-2">
            <span className="italic text-primary-600">cssbuy sheet</span> game?
          </p>
          <p className="text-2xl md:text-3xl font-heading text-foreground-500 leading-relaxed mb-10">
            Explore the full collection now.
          </p>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center px-8 py-4 rounded-full bg-foreground-900 text-background-50 text-base font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Explore Kaspreadsheet
            <span className="w-4 h-4 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}